import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'getIdsFromQuery',
})
export class GetIdsFromQueryPipe implements PipeTransform {
  transform(value: string | null): number[] {
    return value
      ? value
          .split(',')
          .map((item) => Number(item.trim()))
          .filter((item) => !isNaN(item))
      : [];
  }
}
